module.exports = __webpack_public_path__ + "static/instagram-image-3-8ea8a2c1ffeba73e2cf56197655d82fd.jpg";